import React, { useContext, useEffect } from "react";
import "./App.scss";
import AppContext from "./contexts/appContext";
import { AUTH_CHECK, STATE_WAIT } from "./constants";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import Auth from "./pages/auth";
import HomePage from "./pages/home";
import SignPageWrapper from "./pages/PdfApproval/SignPageWrapper";
import LayoutAside from "./layout/layout-aside";
import ProfilePage from "./pages/profile";
import DRW2IMG from "./pages/drawtoimg";
import { CreateApproval } from "./pages/approvals";
import { CircularProgress } from "@mui/material";

const ProtectedRoute = ({ auth }) => {
  // Show loader until authentication check is complete
  if (auth.state === STATE_WAIT) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    );
  }

  return !!auth?.authed ? (
    <Outlet />
  ) : (
    <Navigate
      to={`/app/auth?redirect=${encodeURIComponent(window.location.pathname)}${encodeURIComponent(window.location.search)}`}
    />
  );
  
};
const App = () => {
  const {
    state: { auth },
    dispatch,
  } = useContext(AppContext);

  useEffect(() => {
    dispatch({ type: AUTH_CHECK });
    return () => {};
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/app" element={<ProtectedRoute auth={auth} />}>
            <Route index element={<Navigate to="approvals" />} />
            <Route path="approvals">
              <Route
                index
                element={
                  <LayoutAside>
                    <HomePage />
                  </LayoutAside>
                }
              />
              <Route
                path="create"
                element={
                  <LayoutAside>
                    <CreateApproval />
                  </LayoutAside>
                }
              />
              <Route
                path="sign/:unique/:token"
                element={<SignPageWrapper />}
              />
            </Route>
            <Route
              path="profile"
              element={
                <LayoutAside>
                  <ProfilePage />
                </LayoutAside>
              }
            />
            <Route
              path="drw2img/:id"
              element={
                <LayoutAside>
                  <DRW2IMG />
                </LayoutAside>
              }
            />
            <Route path="*" element={<h1>404</h1>} />
          </Route>

          <Route path="/app/auth">
            <Route index element={<Auth />} />
            <Route path=":token" element={<Auth />} />
            <Route path="*" element={<h1>404</h1>} />
          </Route>
          
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
